/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';
import { preparePath } from 'utils/preparePath';

const ApiFetchInstance = ApiFetch();

export const URLS = {
  municipalities: '/clients/municipalities',
  coloniesByPostalCode: '/clients/colonies/postal-codes/:postalCode',
  collections: '/clients/collections',
};

export default {
  async getColonies(postalCode) {
    return ApiFetchInstance.get(preparePath(URLS.coloniesByPostalCode, { postalCode }));
  },
  async getCollections() {
    return ApiFetchInstance.get(URLS.collections);
  },
};
